import { resizeObserver } from '../utils/helpers';

window.addEventListener('DOMContentLoaded', () => {
  resizeObserver.observe(document.body);
});
